import React, { useEffect, useMemo } from "react";
import { Paper, Tab, Tabs } from "@material-ui/core";

import { BusinessTable } from "components/Business/BusinessTable/BusinessesList";
import { BusinessRelationsTable } from "components/Business/BusinessRelations/Table";
import { Link, Route, Switch, useRouteMatch } from "react-router-dom";
import { useGetSelectedTabFromRoute } from "hooks/useGetSelectedTabFromRoute";
import history from "appHistory";
import { getManageBusinessRoute } from "lib/navigation";
import { useHasDeploymentPermission } from "hooks";
import { DeploymentPermissions } from "constants/permissions";

export function ManageBusinesses(): React.JSX.Element {
  const match = useRouteMatch();

  const hasRelationshipPermissions = useHasDeploymentPermission(
    DeploymentPermissions.featureBusinessRelations,
  );

  const tabs = useMemo(
    () =>
      [
        {
          label: "Businesses",
          component: BusinessTable,
        },
        hasRelationshipPermissions && {
          label: "Relationships",
          component: BusinessRelationsTable,
        },
      ].filter(Boolean),
    [hasRelationshipPermissions],
  );

  const currentTab = useGetSelectedTabFromRoute(tabs);
  useEffect(() => {
    // If we aren't on a tab, open the first.
    if (!currentTab && tabs[0]?.label) {
      history.push(getManageBusinessRoute(tabs[0].label));
    }
  }, [currentTab, match.path, tabs]);

  const routeMap = ({ label, component }) => (
    <Route path={`${match.path}${label}/`} component={component} key={label} />
  );
  const tabMap = ({ label }) => (
    <Tab
      label={label}
      key={`tab-${label}`}
      value={label}
      data-tour={label}
      component={Link}
      to={`${match.path}${label}/`}
    />
  );

  return (
    <>
      <Paper>
        <Tabs value={currentTab} variant="scrollable">
          {tabs.map(tabMap)}
        </Tabs>
      </Paper>

      <Switch>{tabs.map(routeMap)}</Switch>
    </>
  );
}
